import axios from 'axios';
import { ROOT_URL, getAuthHeaders, isUnauthorizedError } from './constants';

// Constantes para el manejo de acciones sobre el estado de las notificaciones de ventanas.

// Actualización de la notificacion actual en el estado
export const GET_APWINDOW_NOTIFICATION = 'GET_APWINDOW_NOTIFICATION';
export const SEND_APWINDOW_NOTIFICATION_EMAILS = 'SEND_APWINDOW_NOTIFICATION_EMAILS';
export const CHECK_APWINDOW_NOTIFICATION_TEMPLATE = 'CHECK_APWINDOW_NOTIFICATION_TEMPLATE';

/**
 * Crea una notificacion para una ventana de aplicación con los datos dados por parámetro
 *
 * @export createApwindowNotification
 * @param {*} notification : Información de la notificacion a crear.
 * @param {*} apwindow_id : ID de la ventana de aplicación.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 *                                           La función debe recibir por parámetro el error generado.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function createApwindowNotification(notification, apwindow_id, successCallback = () => {}, errorCallback = (error) => {}) {
  
  const request = axios.post(`${ROOT_URL}/apwindows/${apwindow_id}/notifications`, {notification: notification}, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_APWINDOW_NOTIFICATION,
        payload: data
      });
      successCallback();
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Verifica si existe una plantilla de notificación para una ventana de aplicación
 *
 * @export checkApwindowNotificationTemplate
 * @param {*} apwindow_id : ID de la ventana de aplicación.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 *                                           La función debe recibir por parámetro el error generado.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function checkApwindowNotificationTemplate(apwindow_id, successCallback = () => {}, errorCallback = (error) => {}) {
  
  const request = axios.get(`${ROOT_URL}/apwindows/${apwindow_id}/notifications/check_template`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: CHECK_APWINDOW_NOTIFICATION_TEMPLATE,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Envía correos de notificación a todos los estudiantes de una ventana de aplicación
 *
 * @export sendApwindowNotificationEmails
 * @param {*} apwindow_id : ID de la ventana de aplicación.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 *                                           La función debe recibir por parámetro el error generado.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function sendApwindowNotificationEmails(apwindow_id, successCallback = () => {}, errorCallback = (error) => {}) {
  
  const request = axios.post(`${ROOT_URL}/apwindows/${apwindow_id}/notifications/send_emails`, {}, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: SEND_APWINDOW_NOTIFICATION_EMAILS,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
} 